import React, { useEffect } from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function TerminalStickering({
  primaryDetails,
  setPrimaryDetails,
  stickeringError,
  setStickeringError,
  navigation,
}) {

  // Validation logic for stickering section
  const validateStickeringSection = () => {
    const errors = {
      no_stickered_reason: !primaryDetails.no_stickered_reason,
    };
    setStickeringError(errors);

    const hasErrors = Object.values(errors).some(e => e);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.no_stickered_reason;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({ ...prev, [name]: value }));
    if (stickeringError[name]) {
      setStickeringError((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleNext = () => {
    if (validateStickeringSection()) {
      navigation.go('thermal-roll');
    }
  };

  const handleBack = () => {
    navigation?.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
           
              <div className="form-main-header">
                <h4 className="form-title"> NO TERMINAL STICKERING</h4>
                <p className="form-desc">Please provide stickering details</p>
              </div>
               <div className="form-main">
              <div className="form-main-content">
              <Form.Group className="mb-4">
                <Form.Label className="form-label">
                  Unable to perform Terminal Stickering because <span className="form-required">*</span>
                </Form.Label>
                <Form.Select
                  name="no_stickered_reason"
                  value={primaryDetails.no_stickered_reason || ''}
                  onChange={handleChange}
                  className={`form-select${stickeringError.no_stickered_reason ? ' form-input-error' : ''}`}
                >
                  <option value="">Select reason</option>
                  <option value="Terminal has been stickered already">Terminal has been stickered already</option>
                  <option value="HO restriction">HO restriction</option>
                  <option value="Old terminal model">Old terminal model</option>
                  <option value="Defective terminal">Defective terminal</option>
                  <option value="Sticker does not fit">Sticker does not fit</option>
                  <option value="Merchant refused">Merchant refused</option>
                  <option value="TAS has no on-hand terminal sticker">TAS has no on-hand terminal sticker</option>
                  <option value="Other reasons">Other reasons</option>
                </Form.Select>
                {stickeringError.no_stickered_reason && (
                  <div className="form-error">Required</div>
                )}
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label className="form-label">
                  Unable to perform Terminal Stickering details
                </Form.Label>
                <Form.Control
                  type="text"
                  name="num_stickered_detail"
                  value={primaryDetails.num_stickered_detail || ''}
                  onChange={handleChange}
                  placeholder="Short answer text"
                />
              </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TerminalStickering;
